import React from 'react';
import styles from './index.module.scss';
import { OfferTypeAndExpiry } from '../../scenes/OffersPage/components/OfferCard';
import store from '../../assets/global/store.png';
import CustomImg from '../CustomImg/index';
import { useNavigateRoute } from '../../hooks/custom.hooks';

function CutoutCard({
  card,
  onCardClick,
  showClaim = false,
  onClaim = () => {},
  showApplicable = true,
}) {
  const {
    brand_logo = '',
    offer_image = '',
    brand_name,
    offer_title,
    code,
    applicable_brand_logos = {},
    brand_id,
    voucher_campaign_details_id,
    type,
    voucher_id,
    reward_details_id,
  } = card;

  const navigateRoute = useNavigateRoute();

  return (
    <div className={styles.cutoutCard} onClick={() => onCardClick({ card })}>
      <div
        onClick={() =>
          navigateRoute({
            nextPage: `/offer/${brand_id}?vcdi=${voucher_campaign_details_id}&t=${type}&vid=${voucher_id}&rdid=${reward_details_id}`,
          })
        }
        className={styles.cutoutCardSection}
      >
        <div className={styles.topSection}>
          <CustomImg
            loading="lazy"
            src={brand_logo}
            fallbackSrc={offer_image}
            alt={brand_name}
            className={styles.brandBanner}
          />
        </div>
        <div className={styles.bottomSection}>
          <OfferTypeAndExpiry offer={card} />
          <div className={styles.offerInfo}>
            <div className={styles.offerTitle}>{offer_title}</div>
            {applicable_brand_logos.logos.length && showApplicable ? (
              <div className={styles.applicable}>
                <div className={styles.text}>Applicable on</div>
                <div className={styles.logos}>
                  {applicable_brand_logos.logos
                    .slice(0, 4)
                    .map((entry, key) => {
                      return (
                        <CustomImg
                          key={`Brand${key}`}
                          src={entry}
                          fallbackSrc={store}
                          className={styles.applicableIcons}
                        />
                      );
                    })}
                </div>
                {applicable_brand_logos.logos.length > 4 ? (
                  <div>+{applicable_brand_logos.logos.length - 4} more</div>
                ) : null}
                {typeof applicable_brand_logos.extra_count === 'string' ? (
                  <div className={styles.extraCount}>
                    {applicable_brand_logos.extra_count}
                  </div>
                ) : null}
              </div>
            ) : null}
            <div className={styles.couponInfo}>
              <div className={styles.left}>
                <div className={styles.brandLogo}>
                  <CustomImg
                    alt={brand_name}
                    src={brand_logo}
                    fallbackSrc={store}
                    className={styles.brandImg}
                  />
                </div>
                <div className={styles.couponDetails}>
                  <div className={styles.merchantName}>{brand_name}</div>
                  <div className={styles.couponCode}>{code}</div>
                </div>
              </div>
              {showClaim ? (
                <div
                  className={styles.claimBtn}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onClaim({ card });
                  }}
                >
                  Claim
                </div>
              ) : null}
            </div>
          </div>
          <div className={styles.sevenDots}>
            {[
              ...Array(7)
                .fill('*')
                .map((_, key) => (
                  <div key={_ + key} className={styles.dot}></div>
                )),
            ]}
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(CutoutCard);
